import { render, staticRenderFns } from "./index5.vue?vue&type=template&id=59bef518&scoped=true&"
import script from "./index5.vue?vue&type=script&lang=js&"
export * from "./index5.vue?vue&type=script&lang=js&"
import style0 from "./index5.vue?vue&type=style&index=0&id=59bef518&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bef518",
  null
  
)

export default component.exports